// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from "@mui/material";
import { Button } from "../atoms";
import {
    useCreateMerchantHash,
  } from "../../hooks";
  import { useSetSnackBar } from "../../store/Snackbar.state";

interface Props {
  merchantId: string; 
  hashPasswordOpen: boolean;
  setHashPasswordOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

 export const HashPasswordDialog: React.FC<Props> = ({ merchantId, hashPasswordOpen, setHashPasswordOpen, setShouldRefresh }) => {
    const setSnackbar = useSetSnackBar();
    const { mutate: createMerchantHash, isLoading } = useCreateMerchantHash();
    const handleSend = () => {
        createMerchantHash(
          { merchantId: merchantId },
          {
            onSuccess: (data) => {
              if (data.isSuccess) {
                setSnackbar({
                  severity: 'success',
                  description: data.message || 'İşlem başarılı.',
                  isOpen: true,
                });
                setShouldRefresh(prev => !prev);
              } else {
                setSnackbar({
                  severity: 'error',
                  description: data.message,
                  isOpen: true,
                });
              }
            },
            onError: (error) => {
              setSnackbar({
                severity: 'error',
                description: error.message || 'İşlem sırasında bir hata oluştu.',
                isOpen: true,
              });
            }
          }
        );
        setHashPasswordOpen(false);
      };
    
      return (
        <>
          <Dialog open={hashPasswordOpen} onClose={() => setHashPasswordOpen(false)}>
         
            <DialogContent>
              <DialogContentText>
              Üye İşyeri Şifresini Göndermek İstiyor Musunuz?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleSend} color="primary" text='Evet'  variant="contained"   disabled={isLoading}>
                Evet
              </Button>
              <Button onClick={() => setHashPasswordOpen(false)} text='Hayır'  color="primary" variant="outlined" >
                Hayır
              </Button>
          
            </DialogActions>
          </Dialog>
        </>
      );
};


